// export const baseUrl = "http://localhost:8080";

export const baseUrl = "https://api.cns.thecove.it";
